import { useMemo } from 'react';

import { BreakdownsResult } from 'api/useAnalytics';

const DEFAULT_COLORS = [
  '#C7D2FE', // indigo-200
  '#A5B4FC', // indigo-300
  '#818CF8', // indigo-400
  '#3730A3', // indigo-800
  '#1E1B4B' // indigo-950
];

export function usePieChartConfig(breakdown: BreakdownsResult | undefined) {
  return useMemo(() => {
    const chartConfig = breakdown?.values.reduce(
      (acc, { breakdownValue, value }, index) => {
        acc[breakdownValue as string] = {
          label: value as string,
          color: DEFAULT_COLORS[index % DEFAULT_COLORS.length]
        };
        return acc;
      },
      {} as Record<string, { label: string; color: string }>
    );

    const chartData = breakdown?.values.map((breakdown, index) => ({
      ...breakdown,
      value: parseFloat(breakdown.value.toString()),
      fill: DEFAULT_COLORS[index % DEFAULT_COLORS.length]
    }));

    return { chartConfig, chartData };
  }, [breakdown?.values]);
}
